document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.querySelector('.bubble-video__overlay');
  const videoPopup = document.querySelector('.bubble-video__popup');
  const videoElement = document.querySelector('.bubble-video__popup-video');
  const videoSource = document.querySelector('.bubble-video__popup-source');
  document.querySelectorAll('.bubble-video__video').forEach(bubble => {
    bubble.addEventListener('click', function () {
      const videoUrl = this.getAttribute('data-video-url');
      overlay.style.display = 'block';
      videoSource.src = videoUrl;
      videoElement.load();
      videoElement.currentTime = 0;
      videoElement.play();
      videoPopup.style.display = 'block';
    });
  });
  document.querySelectorAll('.bubble-video__popup-close, .bubble-video__overlay').forEach(closeBtn => {
    closeBtn.addEventListener('click', closePopup);
  });
  function closePopup() {
    overlay.style.display = 'none';
    videoElement.pause();
    videoElement.currentTime = 0;
    videoPopup.style.display = 'none';
    videoSource.src = "";
  }

  // Detect if the element is in fullscreen (each browser haver diffetent event)
  function handleFullscreenChange() {
    const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    if (!isFullscreen) {
      closePopup();
    }
  }
  document.addEventListener('fullscreenchange', handleFullscreenChange);
  document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
  document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
  document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE

  // This event is to avoid double click to close the popup on Safari iOS
  videoElement?.addEventListener('webkitendfullscreen', () => {
    closePopup();
  });

  // Open description tab on size guide click
  document.querySelector('.tool-tip-trigger__title--open-desc')?.addEventListener('click', () => {
    document.querySelector('#product-block--tab-description')?.closest('.product-block').querySelector('button[aria-expanded="false"]')?.click();
  });

  // Open the tab if the URL contain the id
  if (window.location.hash.includes('#product-block--tab-description')) {
    document.querySelector('.tool-tip-trigger__title--open-desc').click();
    descriptionTabAnchorPosition();
  }

  // Raise the anchor to the height of the header
  descriptionTabAnchorPosition();
  window.addEventListener('resize', descriptionTabAnchorPosition());
  function descriptionTabAnchorPosition() {
    let h = document.querySelector('#SiteHeader').offsetHeight;
    if (document.querySelector('#product-block--tab-description')) {
      document.querySelector('#product-block--tab-description').style.top = -h + 'px';
    }
  }
});